module.exports = __webpack_public_path__ + "media/7.99b9a05a.mp3";